import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-add",
  "use": "n-icon-add-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"n-icon-add\">\n    <path d=\"M10 3C10.3866 3 10.7 3.3134 10.7 3.7V9.3H16.3C16.6866 9.3 17 9.6134 17 10C17 10.3866 16.6866 10.7 16.3 10.7H10.7V16.3C10.7 16.6866 10.3866 17 10 17C9.6134 17 9.3 16.6866 9.3 16.3V10.7H3.7C3.3134 10.7 3 10.3866 3 10C3 9.6134 3.3134 9.3 3.7 9.3H9.3V3.7C9.3 3.3134 9.6134 3 10 3Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol